import { render, staticRenderFns } from "./AddRole.vue?vue&type=template&id=b10caf98"
import script from "./AddRole.vue?vue&type=script&lang=js"
export * from "./AddRole.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Volumes/Untitled/project/050/050admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b10caf98')) {
      api.createRecord('b10caf98', component.options)
    } else {
      api.reload('b10caf98', component.options)
    }
    module.hot.accept("./AddRole.vue?vue&type=template&id=b10caf98", function () {
      api.rerender('b10caf98', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/permission/components/AddRole.vue"
export default component.exports